// Shared product constants (PRD §3, §5.4, §6.1). Non-secret.

export const PLANS = {
  monthly: { label: "شهري", labelEn: "Monthly", priceEGP: 1200, months: 1 },
  quarterly: { label: "ربع سنوي", labelEn: "Quarterly", priceEGP: 2800, months: 3 },
} as const;

export type PlanKey = keyof typeof PLANS;

export const MONTHLY_CREDITS = 100;
export const FREE_DESIGNS_PER_MONTH = 30; // D-2

// Credit cost table (PRD §3.4).
export const CREDIT_COST = {
  caption: 1,
  script: 1,
  aiImage: 2,
  editImage: 2,
  freeCanvas: 0,
  carouselCover: 2,
  carouselSlide: 0,
  thumbnail: 2,
  quiz: 0,
} as const;

// 12 Jungian archetypes (PRD §5.4). Select 2–3.
export const ARCHETYPES = [
  "Innocent",
  "Sage",
  "Explorer",
  "Outlaw",
  "Magician",
  "Hero",
  "Lover",
  "Jester",
  "Everyman",
  "Caregiver",
  "Ruler",
  "Creator",
] as const;

export type Archetype = (typeof ARCHETYPES)[number];

export const ARCHETYPE_LABELS_AR: Record<Archetype, string> = {
  Innocent: "البريء",
  Sage: "الحكيم",
  Explorer: "المستكشف",
  Outlaw: "المتمرد",
  Magician: "الساحر",
  Hero: "البطل",
  Lover: "المُحب",
  Jester: "المرِح",
  Everyman: "الإنسان العادي",
  Caregiver: "الراعي",
  Ruler: "الحاكم",
  Creator: "المبدع",
};

// Content types (PRD §6.1). Only "main" is fully built this pass.
export const CONTENT_TYPES = [
  { key: "main", labelAr: "تصميم رئيسي", labelEn: "Main Design", built: true },
  { key: "infographic", labelAr: "إنفوجرافيك", labelEn: "Complex Infographic", built: false },
  { key: "carousel", labelAr: "كاروسيل", labelEn: "Carousel", built: false },
  { key: "before_after", labelAr: "قبل وبعد", labelEn: "Before & After", built: false },
  { key: "reel", labelAr: "سكربت ريل", labelEn: "Reel Scripts", built: false },
  { key: "review", labelAr: "تقييم", labelEn: "Review", built: false },
  { key: "offer", labelAr: "عرض", labelEn: "Offers", built: false },
] as const;

export const REFERENCE_DESIGNS_MAX = 2;
export const DOCTOR_PHOTOS_MIN = 2;
export const DOCTOR_PHOTOS_MAX = 5;
export const BIO_MAX = 500;
